const fixHTMLString = (html: string) => {
  return html.replace(/<em[^>]*>|<em\/>/g, '')
    .replace(/(style\s*=\s*\"[^"]+\";?)/g, '')
}
export default fixHTMLString